import { Tooltip } from "@xola/ui-kit";
import { ItemActionOption, PurchaseActionOption, RosterActionOption } from "common";
import React from "react";
import { Menu } from "./Menu";
import { SecondaryButton } from "./SecondaryButton";

type ButtonClick = (value: PurchaseActionOption | RosterActionOption) => void;

interface ItemActionMenuProps {
    actions: ItemActionOption[];
    onClick: ButtonClick;
}

export const ItemActionMenu = ({ actions, onClick }: ItemActionMenuProps) => {
    return (
        <>
            {actions.map((item) => {
                return <ItemMenu key={item.title} item={item} onClick={onClick} />;
            })}
        </>
    );
};

const ItemMenu = ({ item, onClick }: { item: ItemActionOption; onClick: ButtonClick }) => {
    if (item.disabled) {
        return null;
    }

    const handleClick = (e: any) => {
        e.stopPropagation();
        if (typeof item.action !== undefined) {
            onClick(item.action);
        }
    };

    const isDisabled = item.isLoading ?? !!item.disabled;

    return (
        <Menu.Item icon={item.icon} isDisabled={isDisabled ?? false} onClick={handleClick}>
            <div className="flex w-full flex-row items-center justify-between space-x-5">
                <div>{item.title}</div>
                <div className="flex space-x-1">
                    {item.suboptions?.map((subMenuItem) => {
                        return <SubMenuItem key={subMenuItem.title} subMenuItem={subMenuItem} onClick={onClick} />;
                    })}
                </div>
            </div>
        </Menu.Item>
    );
};

const SubMenuItem = ({ subMenuItem, onClick }: { subMenuItem: ItemActionOption; onClick: ButtonClick }) => {
    const handleClick = (e: any) => {
        e.stopPropagation();
        if (typeof subMenuItem.action !== undefined) {
            onClick(subMenuItem.action);
        }
    };

    return (
        <Tooltip content={subMenuItem.title}>
            <SecondaryButton size="small" data-testid={subMenuItem.title} onClick={handleClick}>
                {subMenuItem.icon}
            </SecondaryButton>
        </Tooltip>
    );
};
